"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _EmbedIframe = _interopRequireDefault(require("./EmbedIframe"));

var _embed = require("../../constants/embed");

var MAX_PREVIEW_HEIGHT = 300;
var IFRAME_PREVIEW_ID = 'embed-modal-preview';
var initialStyles = {
  iframeStyle: {
    width: '100%',
    height: MAX_PREVIEW_HEIGHT + "px",
    border: 'none'
  },
  containerStyle: {
    overflow: 'hidden',
    display: 'none'
  }
};

function styleReducer(state, action) {
  switch (action.type) {
    case 'UPDATE_IFRAME_STYLE':
      return {
        iframeStyle: Object.assign({}, state.iframeStyle, {}, action.payload),
        containerStyle: Object.assign({}, state.containerStyle)
      };

    case 'UPDATE_CONTAINER_STYLE':
      return {
        iframeStyle: Object.assign({}, state.iframeStyle),
        containerStyle: Object.assign({}, state.containerStyle, {}, action.payload)
      };

    default:
      return state;
  }
}

var EmbedIframeContainer = _styledComponents.default.div.withConfig({
  displayName: "EmbedLivePreview__EmbedIframeContainer",
  componentId: "sc-1c2o9vm-0"
})(["max-height:", "px;"], MAX_PREVIEW_HEIGHT);

var ContentEmbedUIOrigin = (0, _embed.getContentEmbedUIOrigin)();

function EmbedLivePreview(props) {
  var html = props.data.html,
      onSetContentDone = props.onSetContentDone,
      showPreview = props.showPreview;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      targetWindow = _useState2[0],
      setTargetWindow = _useState2[1];

  var _useReducer = (0, _react.useReducer)(styleReducer, initialStyles),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      styles = _useReducer2[0],
      dispatchStyles = _useReducer2[1];

  var contentRef = (0, _react.useRef)(html);
  var postMessageToIframe = (0, _react.useCallback)(function (msg) {
    if (!targetWindow) return;
    targetWindow.postMessage(Object.assign({}, msg, {
      id: IFRAME_PREVIEW_ID
    }), ContentEmbedUIOrigin);
  }, [targetWindow]);
  (0, _react.useEffect)(function () {
    var payload = {
      display: showPreview ? 'flex' : 'none'
    };

    if (!showPreview) {
      // Reset the scroll overflow
      payload.overflow = 'hidden';
    }

    dispatchStyles({
      type: 'UPDATE_CONTAINER_STYLE',
      payload: payload
    });
  }, [showPreview]);
  (0, _react.useEffect)(function () {
    if (!html) return;
    contentRef.current = html; // Asynchronously set the iframe content if `html` prop changed after
    // the connection with the Iframe was already made

    postMessageToIframe({
      action: _embed.ContentEmbedUIEvents.SET_CONTENT,
      payload: {
        html: html
      }
    });
  }, [postMessageToIframe, html]);
  (0, _react.useEffect)(function () {
    var onPostMessage = function onPostMessage(evt) {
      var origin = evt.origin,
          source = evt.source,
          data = evt.data;

      if (!targetWindow || origin !== ContentEmbedUIOrigin || source !== targetWindow) {
        return;
      } // Interframe messages are encapsulated in the { body } property


      var _ref = data.body || {},
          action = _ref.action,
          id = _ref.id,
          payload = _ref.payload;

      if (id !== IFRAME_PREVIEW_ID) return;

      if (action === _embed.ContentEmbedUIEvents.READY && contentRef.current) {
        postMessageToIframe({
          action: _embed.ContentEmbedUIEvents.SET_CONTENT,
          payload: {
            html: contentRef.current
          }
        });
      } else if (action === _embed.ContentEmbedUIEvents.SET_CONTENT_DONE) {
        onSetContentDone();
        dispatchStyles({
          type: 'UPDATE_CONTAINER_STYLE',
          payload: {
            display: 'flex'
          }
        });
      } else if (action === _embed.ContentEmbedUIEvents.SIZE_CHANGE) {
        var newHeight = payload.height;

        if (newHeight !== 0) {
          dispatchStyles({
            type: 'UPDATE_IFRAME_STYLE',
            payload: {
              height: newHeight + "px"
            }
          });
          dispatchStyles({
            type: 'UPDATE_CONTAINER_STYLE',
            payload: {
              overflow: newHeight > MAX_PREVIEW_HEIGHT ? 'auto' : 'hidden'
            }
          });
        }
      }
    };

    window.addEventListener('message', onPostMessage);
    return function () {
      // Cleanup the content-embed-ui app
      postMessageToIframe({
        action: _embed.ContentEmbedUIEvents.DISCONNECT
      });
      window.removeEventListener('message', onPostMessage);
    };
  }, [targetWindow, postMessageToIframe, onSetContentDone]);
  var containerStyle = styles.containerStyle,
      iframeStyle = styles.iframeStyle;
  return _react.default.createElement(EmbedIframeContainer, {
    style: containerStyle
  }, _react.default.createElement(_EmbedIframe.default, {
    inpage: false,
    embedId: IFRAME_PREVIEW_ID,
    style: iframeStyle,
    iframeRef: function iframeRef(el) {
      if (el && el.contentWindow) {
        setTargetWindow(el.contentWindow);
      }
    }
  }));
}

var _default = EmbedLivePreview;
exports.default = _default;
EmbedLivePreview.propTypes = {
  data: _propTypes.default.object.isRequired,
  onSetContentDone: _propTypes.default.func.isRequired,
  showPreview: _propTypes.default.bool
};
EmbedLivePreview.defaultProps = {
  showPreview: false
};
module.exports = exports.default;